// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1Pbla","info":"Note_info__27vXk","note":"Note_note__1agmb","actions":"Note_actions__2hzkT"};